import { TableCell, TableRow, Stack, Collapse, Table, Tooltip, IconButton } from '@mui/material';
import React, { useContext, useState } from 'react';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { generateRandomUUID } from '../../../../../../../libs/HelperContent';
import { LanguageContext } from '../../../../../../../libs/Context';

const QuestionsTable = (props) =>
{
	const { survey, handleAction, handleDelete, index, showDelete } = props;
	const [ deletePopup, setDeletePopup ] = useState(false);
	const [ expand, setExpand ] = useState(false);

	const handleExpand = () =>
	{
		setExpand(!expand);
	};
	const getType = {
		short          : 'Short Answer',
		singleChoice   : 'Single Choice',
		multipleChoice : 'Multiple Choice',
		star           : 'Star Rating'
	};

	const toggleDelete = () => { setDeletePopup(!deletePopup); };
	const { language } = useContext(LanguageContext);

	const handleDeleteClick = () =>
	{
		handleDelete(index);
		toggleDelete();
	};

	return (
		<>
			<TableRow>
				<TableCell
					sx={{
						overflow     : 'hidden',
						textOverflow : 'ellipsis',
						whiteSpace   : 'nowrap',
						maxWidth     : '300px'
					}} className='firstLetter'
				>
					{/* {survey.id}. */}
					{survey.question}
				</TableCell>
				<TableCell>
					{getType[survey?.questionType]}
				</TableCell>
				<TableCell >
					<Stack direction={'row'} spacing={2}>
						<MdOutlineEdit
							cursor={'pointer'}
							fontSize='var(--pixel22)' color='var(--txtColorBlackL)'
							onClick={() => handleAction('edit', survey?.questionId)}
						/>
						{showDelete &&
						<Tooltip title={language?.delete} placement='top'>
							<IconButton>
								<RiDeleteBinLine cursor={'pointer'}
									fontSize='var(--pixel22)' color='var(--txtColorBlackL)'
									onClick={toggleDelete}
								/>
							</IconButton>
						</Tooltip>}
					</Stack>
				</TableCell>
				<TableCell >
					{[ 'singleChoice', 'multipleChoice' ]?.includes(survey?.questionType) &&
					<Stack direction={'row'} spacing={2}
						onClick={handleExpand}
					>
						{!expand
							? <IoMdArrowDropdown cursor={'pointer'} fontSize='var(--pixel24)' />
							: <IoMdArrowDropup cursor={'pointer'} fontSize='var(--pixel24)'/>}
					</Stack>
					}
				</TableCell>

			</TableRow>
			{survey?.options && (
				<TableRow sx={{ background: 'var(--whiteLight)', '& > *': { borderBottom: 'none' } }}>
					<TableCell style={{ padding: 0 }} colSpan={6}>
						<Collapse in={expand} timeout='auto' unmountOnExit>
							<Table aria-label='survey'>
								{survey?.options?.length && survey?.options?.map((item, ind) =>
								{
									return (
										<TableRow key={item?._id ?? item?.id ?? ind}>
											<TableCell sx={{ minWidth: '150px' }}>
												{item}
											</TableCell>
										</TableRow>
									);
								})}
							</Table>
						</Collapse>
					</TableCell>
				</TableRow>
			)}

			{deletePopup &&
			<NewDialogPopup
				open={deletePopup}
				handleConfirm={toggleDelete}
				closeCallBack={handleDeleteClick}
				type={language?.no}
				id={undefined}
				label={language?.confirmDeleteQuestion}
				from='feedCreate'
				formatType={language.yes}
			/>
			}
		</>
	);
};

export default QuestionsTable;